import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const NAV = [
  { path: '/today', icon: '📅', label: 'Today' },
  { path: '/history', icon: '📋', label: 'History' },
  { path: '/trends', icon: '📈', label: 'Trends' },
  { path: '/plan', icon: '🏋️', label: 'Plan' },
  { path: '/profile', icon: '👤', label: 'Profile' },
];

export default function Sidebar({ mobileOpen, onClose }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <>
      {mobileOpen && (
        <div
          onClick={onClose}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
            zIndex: 99, display: 'none'
          }}
          className="sidebar-overlay"
        />
      )}
      <aside className={`sidebar ${mobileOpen ? 'open' : ''}`}>
        {/* Logo */}
        <div style={{ padding: '24px 20px 20px', borderBottom: '1px solid var(--border)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{
              width: 36, height: 36, background: 'var(--red)',
              borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 18
            }}>🏋️</div>
            <div>
              <div style={{ fontFamily: 'var(--font-display)', fontSize: 16, letterSpacing: '0.05em', lineHeight: 1 }}>
                MY IRON
              </div>
              <div style={{ fontFamily: 'var(--font-display)', fontSize: 16, letterSpacing: '0.05em', color: 'var(--red)', lineHeight: 1 }}>
                JOURNAL
              </div>
            </div>
          </div>
        </div>

        {/* Nav */}
        <nav style={{ flex: 1, padding: '16px 12px', display: 'flex', flexDirection: 'column', gap: 4 }}>
          {NAV.map(({ path, icon, label }) => (
            <NavLink
              key={path}
              to={path}
              onClick={onClose}
              style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: 10,
                padding: '10px 12px', borderRadius: 'var(--radius)',
                fontWeight: 500, fontSize: 14,
                color: isActive ? 'var(--text)' : 'var(--text-2)',
                background: isActive ? 'var(--surface)' : 'transparent',
                borderLeft: isActive ? '3px solid var(--red)' : '3px solid transparent',
                transition: 'all var(--transition)',
                textDecoration: 'none',
              })}
            >
              <span style={{ fontSize: 18 }}>{icon}</span>
              {label}
            </NavLink>
          ))}
        </nav>

        {/* User info + logout */}
        <div style={{ padding: '16px 12px', borderTop: '1px solid var(--border)' }}>
          {user && (
            <div style={{ marginBottom: 12, padding: '10px 12px', background: 'var(--bg-3)', borderRadius: 'var(--radius)' }}>
              <div style={{ fontWeight: 600, fontSize: 14 }}>{user.username}</div>
              <div style={{ fontSize: 12, color: 'var(--text-3)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {user.email}
              </div>
            </div>
          )}
          <button onClick={handleLogout} className="btn btn-ghost btn-sm btn-full" style={{ justifyContent: 'flex-start' }}>
            🚪 Sign Out
          </button>
          <p style={{ fontSize: 11, color: 'var(--text-3)', textAlign: 'center', marginTop: 12, opacity: 0.5 }}>
            © 2026 StormForge Labs LLC
          </p>
        </div>
      </aside>
    </>
  );
}
